import * as React from 'react';
import { format } from 'date-fns';
import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { periodTypeLabel } from '@utils/utils';

export default [
  {
    label: 'Název',
    field: 'label',
    type: ColumnType.JSX,
    width: 50,
    jsx: ({ row }) => (
      <div
        style={{
          display: 'inline-block',
          borderBottom: `5px solid ${get(row, 'color', 'transparent')}`,
          padding: `0 5px`
        }}
      >
        {get(row, 'label')}
      </div>
    )
  },
  {
    label: 'Popis',
    field: 'description',
    type: ColumnType.TEXT,
    width: 50
  },
  {
    label: 'Zaměstnanec',
    field: 'employee',
    type: ColumnType.TEXT,
    width: 200,
    mapper: employee => `${get(employee, 'firstName')} ${get(employee, 'lastName')}`
  },
  {
    label: 'Intervaly',
    field: 'periods',
    type: ColumnType.JSX,
    jsx: ({ row }) => (
      <div>
        {get(row, 'periods', []).map((period: any) => (
          <div key={get(period, 'id')}>
            {periodTypeLabel(get(period, 'type'))} {format(get(period, 'from', ''), 'DD. MM. YYYY HH:mm')} -{' '}
            {format(get(period, 'to', ''), 'DD. MM. YYYY HH:mm')}
          </div>
        ))}
      </div>
    ),
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-dayplans/_dayplansColumns.tsx